import { inject, injectable } from "inversify";
import { ICPLSLATypesClient, IntSelectModel, SLATypeModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface ISLATypesService {
  getSLATypes(): Promise<SLATypeModel[]>;
  createSLAType(name: string, targetMinutes: number): Promise<void>;
  updateSLAType(slaTypeModel: SLATypeModel): Promise<void>;
  deleteSLAType(slaTypeID: number): Promise<void>;
  getSLATypeSelectModels(): Promise<IntSelectModel[]>;
  calculateSLATargetDate(startDate: Date, slaTypeID: number): Promise<Date>;
}

@injectable()
export class SLATypesService implements ISLATypesService {
  @inject(SERVICE_TYPES.CPLSLATypesClient) cplSLATypesClient!: ICPLSLATypesClient;

  async getSLATypes(): Promise<SLATypeModel[]> {
    return this.cplSLATypesClient.getSLATypes();
  }

  async createSLAType(name: string, targetMinutes: number): Promise<void> {
    return this.cplSLATypesClient.createSLAType(name, targetMinutes);
  }

  async updateSLAType(slaTypeModel: SLATypeModel): Promise<void> {
    return this.cplSLATypesClient.updateSLAType(slaTypeModel);
  }

  async deleteSLAType(slaTypeID: number): Promise<void> {
    return this.cplSLATypesClient.deleteSLAType(slaTypeID);
  }

  async getSLATypeSelectModels(): Promise<IntSelectModel[]> {
    return this.cplSLATypesClient.getSLATypeSelectModels();
  }

  async calculateSLATargetDate(startDate: Date, slaTypeID: number): Promise<Date> {
    return this.cplSLATypesClient.calculateSLATargetDate(startDate, slaTypeID);
  }
}
